import * as _ from 'underscore';

import { ISchedule } from '../../schedule/types/ISchedule';
import { IAccelerationTaskInfo } from '../models/IAccelerationTaskInfo';
import { IAccelerationTask } from '../ServerApi/types/IAccelerationTask';
import { ISiteNameWithId } from '../ServerApi/types/ISiteNameWithId';
import { IUser } from '../ServerApi/types/IUser';
import { INamedItem } from '../ServerApi/types/resourceParts';
import { MapperHelper } from './MapperHelper';

export module AccelerationTaskMapper {

  export function map(
    dcs: IAccelerationTask[],
    schedule: _.Dictionary<ISchedule>,
    site: _.Dictionary<ISiteNameWithId>,
    workbooks: _.Dictionary<INamedItem>,
    projects: _.Dictionary<INamedItem>,
    users: _.Dictionary<IUser>): IAccelerationTaskInfo[] {

    return _.map(dcs, (et: IAccelerationTask) => {
      return {
        id:          et.id,
        contentType: 'accelerationTask',
        lastRunAt:   MapperHelper.toDate(et.lastRunAt),
        schedule:    schedule[et.scheduleId],
        site:        site[et.siteId],
        workbook:    workbooks[et.targetId],
        project:     projects[et.projectId],
        owner:       users[et.userId]
      };
    });
  }

}
